// removed by extract-text-webpack-plugin
module.exports = {"container":"active-filter-item__container___1pXKe","remove-button":"active-filter-item__remove-button___2j_8V"};


//////////////////
// WEBPACK FOOTER
// ./src/scss/components/documents/active-filter-item.scss
// module id = 1316
// module chunks = 0